import React from 'react';
import FooterDrawer from '@/components/ui/atoms/FooterDrawer';
import styles from './MProfilePicker.module.css';

/**
 * MemberPickerDrawer - a stateless, reusable drawer for member selection (used by MProfilePicker and Select Owner).
 * Props:
 * - open: boolean
 * - members: array of member objects
 * - selectedId: id of currently selected member
 * - onSelect: callback with member object when selected
 * - onClose: callback to close the drawer
 * - title: drawer title
 */
const MemberPickerDrawer = ({ open, members, selectedId, onSelect, onClose, title = 'Select Owner' }) => (
  <FooterDrawer open={open} onClose={onClose} title={title} showClose height="auto">
    <div className={styles.membersList} style={{ padding: 'var(--scale-padding-2xl, 24px)' }}>
      {members.map(member => (
        <button
          key={member.id}
          type="button"
          className={[
            styles.memberDrawerButton,
            selectedId === member.id ? styles.memberButtonActive : ''
          ].filter(Boolean).join(' ')}
          onClick={() => onSelect(member)}
        >
          {member.avatar ? (
            <img
              src={member.avatar}
              alt={member.first_name || ''}
              className={styles.memberAvatar}
              style={{ objectFit: 'cover', border: '1px solid #e5e7eb', background: '#E5E7EB', minWidth: 40 }}
            />
          ) : (
            <span className={styles.memberAvatar}>
              {(member.first_name?.[0] || '') + (member.last_name?.[0] || '')}
            </span>
          )}
          <div className={styles.memberInfo}>
            <span className={styles.memberName}>
              {member.nickname || member.first_name || ''}
            </span>
            {/* <span className={styles.memberRelationship}>
              {member.nickname || member.relationship || ''}
            </span> */}
          </div>
        </button>
      ))}
    </div>
  </FooterDrawer>
);

export default MemberPickerDrawer;
